export const SET_VALUE = 'SET_VALUE';

export type VALUE_TYPE = number;
